"use strict";

var LoggerInstance = require("js-logger").get("PledgeStore");

var AbstractStore = require("./AbstractStore");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ProjectStore = require("../projectComponents/ProjectStore");

var SponsorshipHelper = require("../sponsorshipComponents/SponsorshipHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var state = {
	isDesignMode: false,
	isInPledgeStatementSession: false,
	isSecure: false,
	minimumAmount: null,
	minimumAmounts: {},
	pledge: {},
	selectedAmount: null,
	selectedAmounts: {},
	selectedFrequencies: {},
	selectedFrequency: null,
	wizardCheckoutDisplayMessages: {},
	wizardFrequencies: {},
	wizardPledgeCompletionDefaults: {},
	wizardPledgeStatementEntry: {},
	wizardSecurePledges: {},
	wizardShoppingCartDisplayMessages: {},
	wizardSponsorshipDefaults: {},
	wizardSponsorshipDisplayMessages: {},
	isSponsorshipAvailable: true
};

var PledgeStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.PLEDGE_INITIALIZE:
					state.isDesignMode = action.options.isDesignMode;
					state.isInPledgeStatementSession = action.options.isInPledgeStatementSession;
					state.pledge = action.options.pledge;
					state.wizardCheckoutDisplayMessages = action.options.wizardCheckoutDisplayMessages;
					state.wizardFrequencies = action.options.wizardFrequencies;
					state.wizardPledgeCompletionDefaults = action.options.wizardPledgeCompletionDefaults;
					state.wizardPledgeStatementEntry = action.options.wizardPledgeStatementEntry;
					state.wizardShoppingCartDisplayMessages = action.options.wizardShoppingCartDisplayMessages;
					state.wizardSponsorshipDefaults = action.options.wizardSponsorshipDefaults;
					state.wizardSponsorshipDisplayMessages = action.options.wizardSponsorshipDisplayMessages;
					state.isSponsorshipAvailable = action.options.isSponsorshipAvailable;

					document.addEventListener("DOMContentLoaded", (event) => {
						if (state.pledge && !$("[data-react-component-name='PledgeButtonFrequency'],[data-react-component-name='PledgeRadioFrequency'],[data-react-component-name='PledgeSelectFrequency']").length) {
							//We don't have a frequency, so we need to update the amount, and the frequency will be retrieved from the default frequency
							var pledgeCode = (state.pledge || {}).PledgeCode;
							this.updateAmount(/*context*/null, pledgeCode);
						}
					});
					return true; // Don't emit change

				case Constants.PLEDGE_SET_GIFT_AMOUNT:
					if (action.context) {
						if (!state.selectedAmounts[action.context]) {
							state.selectedAmounts[action.context] = {};
						}
						state.selectedAmounts[action.context][action.tangibleCode] = action.selectedAmount;
					} else {
						state.selectedAmount = action.selectedAmount;
					}
					break;

				case Constants.PLEDGE_SET_FREQUENCY:
					if (action.context) {
						if (!state.selectedFrequencies[action.context]) {
							state.selectedFrequencies[action.context] = {};
						}
						state.selectedFrequencies[action.context][action.tangibleCode] = action.selectedFrequency;
					} else {
						state.selectedFrequency = action.selectedFrequency;
					}

					// If we're one-time for this component, we need to hide the recurring component
					if (action.selectedFrequency === "O") {
						$('[data-component="createRecurring"]').hide();
					} else {
						$('[data-component="createRecurring"]').show();
					}

					this.updateAmount(action.context, action.tangibleCode);
					break;

				case Constants.PLEDGE_SET_MINIMUM_AMOUNT:
					if (action.context) {
						if (!state.minimumAmounts[action.context]) {
							state.minimumAmounts[action.context] = {};
						}
						state.minimumAmounts[action.context][action.tangibleCode] = action.minimumAmount;
					} else {
						state.minimumAmount = action.minimumAmount;
					}
					break;

				case Constants.SPONSORSHIP_AVAILABLITY:
					state.isSponsorshipAvailable = action.isSponsorshipAvailable;
					break;

				default:
					// no op
					LoggerInstance.debug(`Undefined action triggered in pledge store. ${action.actionType}`);
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	updateAmount(context, tangibleCode) {
		var tangibleType = (state.pledge || {}).PledgeType;
		if (tangibleType === Constants.TANGIBLE_TYPES.CHILD) {
			// update the component UI to make sure that the SD amount matches what's in the store.
			var $component = $("body").find("[data-dynamic='AmountPerGift']");
			if ($component) {
				var amount = this.getSelectedAmount(context, tangibleCode, tangibleType);
				var formattedAmount = ActionsHelper.formatAmount(amount, $component, /*keepDecimals*/ false);

				$component.text(formattedAmount);
			}
		}
	}

	getMinimumAmount(context, tangibleCode) {
		if (context) {
			if (state.minimumAmounts[context]) {
				return state.minimumAmounts[context][tangibleCode];
			}

			return null;
		}

		return state.minimumAmount;
	}

	getSelectedAmount(context, tangibleCode, tangibleType) {
		var amount = null;
		if (context) {
			if (state.selectedAmounts[context]) {
				amount = state.selectedAmounts[context][tangibleCode];
			}
		} else {
			amount = state.selectedAmount;
		}

		if (amount === null && tangibleType === Constants.TANGIBLE_TYPES.CHILD) {
			// get default amount.
			var defaultAmount = state.pledge["AmountOverride"] || this.getWizardValue(
				WizardConstants.WIZARDS.SPONSORSHIP_DEFAULTS,
				WizardConstants.SPONSORSHIP_DEFAULTS_FIELDS.DEFAULT_AMOUNT
			);

			if (defaultAmount) {
				var selectedFrequency = this.getSelectedFrequency(context, tangibleCode, tangibleType);
				amount = SponsorshipHelper.calculateUpdatedTotal(defaultAmount, selectedFrequency, this.getDefaultPledgeFrequency());
			}
		}

		return amount;
	}

	getSelectedFrequency(context, tangibleCode, tangibleType) {
		var frequency = null;
		if (context) {
			if (state.selectedFrequencies[context]) {
				frequency = state.selectedFrequencies[context][tangibleCode];
			}
		} else {
			frequency = state.selectedFrequency;
		}

		if (frequency === null && tangibleType === Constants.TANGIBLE_TYPES.CHILD) {
			// get default amount.
			var defaultFrequency = state.pledge["FrequencyOverride"] || this.getWizardValue(
				WizardConstants.WIZARDS.SPONSORSHIP_DEFAULTS,
				WizardConstants.SPONSORSHIP_DEFAULTS_FIELDS.DEFAULT_FREQUENCY
			);

			if (defaultFrequency) {
				frequency = defaultFrequency;
			}
		}

		return frequency;
	}

	getDefaultPledgeFrequency() {
		var pledge = state.pledge || {};
		return pledge["FrequencyOverride"] || state.wizardPledgeCompletionDefaults.defaultFrequency;
	}

	getRequireDonation() {
		return state.wizardPledgeCompletionDefaults.requireDonation === "yes";
	}

	getRequireRecurring() {
		return state.wizardPledgeCompletionDefaults.requireRecurring === "yes";
	}

	getIsSecure() {
		return state.isSecure;
	}

	setIsSecure(isSecure) {
		state.isSecure = isSecure;
	}

	getPledgeInformation(cartDataOptions) {
		cartDataOptions = cartDataOptions || {};
		var pledge = state.pledge || {};
		var { context, tangibleCode, tangibleType } = cartDataOptions;

		if (state.isSecure) {
			tangibleCode = state.wizardSecurePledges.pledgeCode || "secure-pledge";
			tangibleType = Constants.TANGIBLE_TYPES.SECURE_PLEDGES;
		}

		tangibleCode = tangibleCode || pledge["PledgeCode"];
		tangibleType = tangibleType || pledge["PledgeType"];

		var pledgeInformation = {
			// Because the pledge information is pulled from the Tangibles table populated from SE, we cannot properly camelCase keys.
			// We are using the bracket notation to indicate that this is intended
			amount: this.getSelectedAmount(context, tangibleCode, tangibleType),
			frequency: this.getSelectedFrequency(context, tangibleCode , tangibleType) || this.getDefaultPledgeFrequency(),
			pledge: tangibleCode,
			pledgeId: pledge["RecordId"],
			projectCode: pledge["DefaultProjectCode"],
			upsell: ProjectStore.getSelectedUpsell(context, tangibleCode),
			useOnDay: ProjectStore.getSelectedUseOnDay(context, tangibleCode),
			startDate: ProjectStore.getSelectedStartDate(context, tangibleCode)
		};

		return pledgeInformation;
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}

	setIsSecure(isSecure) {
		state.isSecure = isSecure;
	}

	setSecurePledgesWizard(securePledgesWizard) {
		state.wizardSecurePledges = securePledgesWizard;
	}
};

module.exports = new PledgeStore(Dispatcher);



// WEBPACK FOOTER //
// ./Javascript/stores/PledgeStore.jsx